import React from "react";

import "react-toastify/dist/ReactToastify.css";

// components
import { ModelCreateTile, ModelEditTile, ProductsUploadTile } from "./index";


const Overstock = () => {

    return (
        <div className="container m-5 p-5">

            <div className="tile is-ancestor">
                <div className="tile is-vertical is-6">
                    <div className="tile">
                        <div className="tile is-parent is-vertical">
                            <ModelCreateTile />
                            <ModelEditTile />
                        </div>
                    </div>
                </div>

                <div className="tile is-parent">
                    <ProductsUploadTile />
                </div>
            </div>

            <div className="tile is-ancestor">
                <div className="tile is-parent">
                    <article className="tile is-12 is-child notification">
                        <p className="title">Last products uploaded</p>
                        <p className="subtitle">SOMETHING</p>
                        <div className="content">
                            <p><strong>HERE</strong></p>
                        </div>
                    </article>
                </div>
            </div>
        </div>
    );
}

export default Overstock;
